
const SpecByteLogo = (props) => {

  return (
    <img src="/static/SpecByteLogoV2.png" width={props.width} />
  )
};

export default SpecByteLogo;
